import React, { memo } from 'react';
import FormNode from '../Components/FormNode/FormNode';
import { Button } from '@mui/material';
import { NodeProps } from 'reactflow';

const SubmitButtonNode = ({ id, type, data }: NodeProps) => {
  return (
    <FormNode id={id} type={type}>
      <Button variant='contained'>Submit</Button>
    </FormNode>
  );
};

export default memo(SubmitButtonNode);
